import { render, staticRenderFns } from "./UnlockAccount.vue?vue&type=template&id=032c9456&scoped=true&"
import script from "./UnlockAccount.vue?vue&type=script&lang=js&"
export * from "./UnlockAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c9456",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032c9456')) {
      api.createRecord('032c9456', component.options)
    } else {
      api.reload('032c9456', component.options)
    }
    module.hot.accept("./UnlockAccount.vue?vue&type=template&id=032c9456&scoped=true&", function () {
      api.rerender('032c9456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/UnlockAccount.vue"
export default component.exports